import { render, staticRenderFns } from "./BupaDemoCard.vue?vue&type=template&id=92667f00"
import script from "./BupaDemoCard.vue?vue&type=script&lang=js"
export * from "./BupaDemoCard.vue?vue&type=script&lang=js"
import style0 from "./BupaDemoCard.vue?vue&type=style&index=0&id=92667f00&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports